import React, { forwardRef } from "react";
import { Tooltip } from "antd";

export const StyledButton = forwardRef(({ 
    size, 
    color, 
    textColor,
    borderColor,
    Icon,
    content,
    tooltip,
    style: propStyle,
    children,
    disabled,
    ...rest
}, ref) => {

    function buttonSizer(size) {
        switch(size) {
            case 'mini':
                return {
                    height: '18px',
                    width: '18px',
                    fontSize: '10px',
                    padding: '8px',
                    borderRadius: '1px',
                }
            case 'small':
                return {
                    height: '25px',
                    width: '25px',
                    fontSize: '16px',
                    padding: '13px',
                    borderRadius: '5px',
                }
            case 'large':
                return {
                    height: '40px',
                    width: '40px',
                    fontSize: '20px',
                    padding: '5px',
                }
            default:
                return {
                    height: '30px',
                    width: '30px',
                    fontSize: '18px',
                    lineHeight: '18px',
                    padding: '5px',
                }
        }
    }

    const style = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px',
        width: '40px',
        height: '40px',
        border: 'none',
        borderRadius: '10px',
        backgroundColor: color || '#7BAD7E',
        color: textColor || 'white',
        cursor: 'pointer',
        transition: 'background-color 0.3s, transform 0.2s',
        fontSize: '20px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        textTransform: 'capitalize',
        ...buttonSizer(size),
        ...(borderColor && { border: `4px solid ${borderColor}` }),
        ...propStyle
    }

    const buttonContent = (
        <button 
            ref={ref}
            style={style}
            {...rest}
            disabled={disabled}
        >
            { Icon && <Icon style={{ margin: 0, fontSize: style.fontSize }}/> }
            { content && <span style={{ margin: 0, fontSize: style.fontSize }}>{content}</span> }
            {children}
        </button>
    )

    return tooltip ? (
        <Tooltip title={tooltip}>
            {buttonContent}
        </Tooltip>
    ) : buttonContent
});
